import React from 'react';
import PropTypes from 'prop-types';
import { ResourceRequestStatus, ResourceMatchesStatus } from '~/types';
import ResourceRequestChartBanner from './ResourceRequestChartBanner';

export const ResourceRequestCalculatingBanner = ({ resourceRequests }) => {
  const submittedResourceRequestUrisWithPendingMatches = resourceRequests.filter(
    resourceRequest =>
      resourceRequest.requestStatus === ResourceRequestStatus.Submitted &&
      resourceRequest.resourceMatchesStatus === ResourceMatchesStatus.InProgress
  );

  return submittedResourceRequestUrisWithPendingMatches.length ? (
    <ResourceRequestChartBanner messageId="resourceRequestChartBanner.calculating" />
  ) : null;
};

ResourceRequestCalculatingBanner.propTypes = {
  resourceRequests: PropTypes.array.isRequired
};
export default ResourceRequestCalculatingBanner;
